import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    const isMultiple = this.element.hasAttribute('multiple') || this.element.multiple
    
    const tomSelect = new TomSelect(this.element, {
      placeholder: isMultiple ? 'Select options' : 'Select an option',
      plugins: isMultiple ? ['remove_button'] : [],
      maxOptions: null,
    })
    
    // Store Tom Select instance on the element for other controllers to access
    this.element.tomselect = tomSelect
    
    // Dispatch change event when Tom Select value changes
    tomSelect.on('change', () => {
      // Use setTimeout to ensure the value is updated before dispatching
      setTimeout(() => {
        this.element.dispatchEvent(new Event('change', { bubbles: true }))
      }, 10)
    })
  }
}
